import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { generateCompleteAnalysis } from '../services/aiService';

export const useAnalyzer = (businessContext, problemStatement, settings) => {
    const theme = useTheme();
    const [answers, setAnswers] = useState([]);
    const [rawAnswers, setRawAnswers] = useState([]);
    const [loadingStates, setLoadingStates] = useState({
        analysis: false,
        submission: false
    });

    const handleAnswer = async (answer) => {
        console.log('Theme in handleAnswer:', theme); // Verify theme object
        console.log('Business Context in useAnalyzer:', businessContext);

        // For the analysis button click (when answer is null)
        if (answer === null && rawAnswers.length === 5) {
            console.log('Sending to AI service:', {
                businessContext,
                problemStatement,
                rawAnswers
            });
    
            setLoadingStates(prev => ({ ...prev, analysis: true }));
            try {
                const analysis = await generateCompleteAnalysis(
                    businessContext,
                    problemStatement,
                    rawAnswers,
                    theme,
                    settings
                      // Pass theme as last argument
                );
                
                if (analysis) {
                    setAnswers([{
                        aiSuggestion: analysis
                    }]);
                }
            } catch (error) {
                console.error('AI Analysis Error:', error);
                setAnswers([{
                    aiSuggestion: {
                        analysis: 'Error generating analysis. Please try again.',
                    }
                }]);
            } finally {
                setLoadingStates({ analysis: false, submission: false });
            }
            return;
        }
    
        // Regular answer handling
        setLoadingStates(prev => ({ ...prev, submission: true }));
        const updatedAnswers = [...rawAnswers, answer];
        setRawAnswers(updatedAnswers);
        setLoadingStates(prev => ({ ...prev, submission: false }));
        return updatedAnswers.length;
    };

    return {
        answers,
        rawAnswers,
        loadingStates,
        handleAnswer
    };
};